import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { useDiagnosticsByIds } from "@/hooks/diagnostic/useDiagnosticsByIds";

export function FaultSourceCell(props: GridRenderCellParams) {
  const { t } = useTranslation();
  const { data: diagnostics } = useDiagnosticsByIds([props.row.faultDId]);

  const diagnostic = diagnostics?.[props.row.faultDId];
  return (
    <Tooltip
      sx={{ m: "auto" }}
      title={t("diagnosticEdit.source") + ":  " + (diagnostic?.source ?? "N/A")}
    >
      <Box
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props.formattedValue || "---"}
      </Box>
    </Tooltip>
  );
}
